import React, { useState, useEffect, useCallback } from 'react';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import Iframe from 'react-iframe'
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '../../../CommonComponents/AssetsHelper';
import { PREVIEW_URL } from '../../../../actions/api';

const Preview = () => {
    const [loading, setLoading] = useState(true);
    const { wallData } = useSelector(state => state.wallData, shallowEqual);
    const themeId = wallData && Object.keys(wallData).length > 0 && wallData.wall ? wallData.wall?.Personalization?.ThemeRule.themeId : 0;
    var url = `${PREVIEW_URL}${localStorage.getItem('wallId')}`
    url = `${url}${themeId > 61 ? `` : `?preview=1`}`;
    
    const [screenZoom, setscreenZoom] = useState(false);
    const [square, setSquare] = useState('btn-square');

    const previewScreen = useFullScreenHandle();
    const dispatch = useDispatch();

    const reportChange = useCallback((state, handle) => {
        previewScreen ? setSquare('exit-full') : setSquare('btn-square');

        setscreenZoom(previewScreen);
    }, [previewScreen]);


    const updatePreview = (e) => {

        document.querySelectorAll(".btn").forEach(e => {
            e.classList.remove("active");
        });

        document.querySelector(`.${e}`).classList.add("active");

        if (e == 'p_desktop') {

            document.querySelectorAll(".device").forEach(e => {
                e.classList.remove("device-tablet-p");
                e.classList.remove("device-mobile-p");
            });

            document.querySelector(`.device`).classList.add("device-desktop");
        }

        if (e == 'p_tablet') {

            document.querySelectorAll(".device").forEach(e => {
                e.classList.remove("device-desktop");
                e.classList.remove("device-mobile-p");
            });

            document.querySelector(`.device`).classList.add("device-tablet-p");

            $(".device-tablet-p").width();
            $(".device-tablet-p").height();
        }

        if (e == 'p_mobile') {

            document.querySelectorAll(".device").forEach(e => {
                e.classList.remove("device-tablet-p");
                e.classList.remove("device-desktop");
            });

            document.querySelector(`.device`).classList.add("device-mobile-p");
        }
    }


    useEffect(() => {

        if(wallData){
            const newTheme = themeId && themeId < 62;
            dispatch(({wallId: wallData.wallId, themeId, status: newTheme ? 1 : 0, ownerId : wallData.wallOwner }, wallData, newTheme ? 62 :  58, ()=>setLoading(false)));
        }else{
            setLoading(false);
        }
        window.isPreview = true
        return () => {
        window.isPreview = false   
        }
    },[])
   
    return (!loading && wallData && Object.keys(wallData).length > 0? <div className={`d-flex flex-column-fluid ${!screenZoom.active ? 'full_view' : null}`} id="preview__">
        <div className="container-fluid p-0">
            <FullScreen handle={previewScreen} onChange={reportChange}>
                <div className="preview_header">
                    <div className={`sub_header_top   ${!screenZoom.active ? 'subheader' : null}`}>
                        <div className="container-fluid">
                            <div className="preview_cont">
                                <div className="row">
                                    <div className="col-sm-5 ps-0">
                                        <div className="d-flex align-items-center flex-nowrap p_wall_title">
                                            <Link className="btn btn-icon btn-clean btn-lg btn-square preview_btn border-right" to={`/wall/index/${wallData.wallId}`} data-factors-click-bind="true">
                                                <FontAwesomeIcon type={'regular'} icon={'angle-left'} iconClass={'fs-2'} />
                                            </Link>
                                            <h5 className="m-0 ps-3 text-nowrap overflow-hidden py-4">
                                            {wallData ? (wallData.wall && Object.keys(wallData.wall).length > 0) ? wallData.wall.name : '' : ''}
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-sm-2 col-6">
                                        <ul className="d-flex align-items-center list-inline mb-0 flex-nowrap p_device_btn">
                                            <li className="nav-item">
                                                <button onClick={(e) => updatePreview('p_desktop')} type="button" className="btn btn-icon btn-clean btn-lg btn-square preview_btn p_desktop active" data-factors-form-bind="true" data-factors-click-bind="true">
                                                    <FontAwesomeIcon type={'regular'} icon={'display'} iconClass={'fs-4'} />
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button onClick={(e) => updatePreview('p_tablet')} type="button" className="btn btn-icon btn-clean btn-lg btn-square preview_btn p_tablet" data-factors-form-bind="true" data-factors-click-bind="true">
                                                    <FontAwesomeIcon type={'regular'} icon={'mobile'} iconClass={'fs-4'} />
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-sm-5 col-6 pe-0">
                                        <div className="d-flex align-items-center justify-content-end p_fullscreen">
                                            <button onClick={screenZoom.active ? previewScreen.exit : previewScreen.enter} id="preview_btn" className={`btn btn-icon btn-clean btn-lg btn-square preview_btn ${previewScreen.active ? `exit-full` : null}`} data-factors-form-bind="true" data-factors-click-bind="true">
                                                <FontAwesomeIcon type={'regular'} icon={'arrow-up-right'} iconClass={'fs-4'} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="preview display_preview">
                    <div className="main_preview">
                        <div className="device device-desktop">
                            <Iframe src={url}></Iframe>
                        </div>
                    </div>
                </div>
            </FullScreen>
        </div>
    </div>:null
    );
};

export default Preview;